import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "trigger"];

  connect() {
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    if (this?.triggerTarget) {
      this.triggerTarget.addEventListener("click", this.toggleMenu);
    }
    document.addEventListener("click", this.closeMenu);
  }

  disconnect() {
    this.triggerTarget.removeEventListener("click", this.toggleMenu);
    document.removeEventListener("click", this.closeMenu);
  }

  toggleMenu(event) {
    // event.preventDefault();
    // event.stopPropagation();
    this.menuTarget.classList.toggle("hidden");
  }

  closeMenu(event) {
    if (
      !this.element.contains(event.target) &&
      !this.menuTarget.classList.contains("hidden")
    ) {
      this.menuTarget.classList.add("hidden");
    }
  }
}
